import Axios from "axios";
import { isNull } from "lodash";
import { decamelizeKeys, camelizeKeys } from "humps";
import NavigationService from "services/navigation";

function getDataFromResponse(response) {
  const baseData = response.data;

  if (isNull(baseData.data)) return null;
  else if (!baseData.data) return baseData;
  else return baseData.data;
}

const axiosApi = Axios.create({
  baseURL: process.env.REACT_APP_API_URL,
  headers: {
    "Content-Type": "application/json",
    Accept: "application/json",
    "Cache-Control": "no-cache",
    "Access-Control-Allow-Origin": "*",
  },
  mode: 'cors',
  credentials: 'include'
});

axiosApi.interceptors.request.use((config) => {
  const jwt = localStorage.getItem("token");
  if (jwt) config.headers.Authorization = `Bearer ${jwt}`;
  return {
  ...config,
  data: decamelizeKeys(config.data),
  };
});

axiosApi.interceptors.response.use(
  (response) => {
    const camelizedData = camelizeKeys(getDataFromResponse(response));
    return { ...response, data: camelizedData };
  },
  (error) => {
    const formatedError = camelizeKeys(error);
    const { status } = formatedError.response;
    if (status === 401) {
      localStorage.removeItem("token");
      NavigationService.navigate("/login");
    } else if (status === 403) {
      NavigationService.navigate("/login");
    }
    throw formatedError;
  }
);

export default axiosApi;
